import { InvoiceItem } from '../types'

const isDefaultEmptyRate = (rate: InvoiceItem['rate']): boolean =>
  rate === '' || rate == null || rate === 0 || rate === '0'

/** Unfilled line item added via "Add Line Item" — not meaningful draft content. */
export const isDefaultEmptyPlaceholderItem = (item: InvoiceItem): boolean =>
  !item.description?.trim()
  && isDefaultEmptyRate(item.rate)
  && (item.quantity === 1 || item.quantity === '1')
  && (!item.amount || item.amount === '')

export const normalizeDraftItems = (items: InvoiceItem[] | undefined): InvoiceItem[] => {
  if (!Array.isArray(items)) return []
  if (items.length === 1 && isDefaultEmptyPlaceholderItem(items[0])) {
    return []
  }
  return items
}
